// eslint-disable-next-line import/no-anonymous-default-export
export default {
  dashboardPage: "لوحة البيانات",
  driversRequests: "طلبات السائقيين",
  search: "ابحث",
  pending: "قيد الانتظار",
  approved: "موافق عليه",
  accident: "حادث",
  vehicleBrokeDown: "المركبة معطلة",
  personalIssues: "اسباب شخصية",
  requestDetails: "تفاصيل الطلب",
  orderStatus: "حالة الطلب",
  reason: "السبب",
  driverExplanation: "شرح سبب السائق",
  adminExplanation: "سبب الرفض",
  oldDriverName: "السائق الحالي",
  newDriverName: "السائق الجديد",
  newDriverLocation: "موقع السائق الجديد",
  streetName: "اسم الشارع",
  files: "الملفات",
  profilePicture: "صورة الملف الشخصي",
  identificationImageFront: "صورة التعريف الأمامية",
  identificationImageBack: "صورة التعريف الخلفية",
  driverLicence: "رخصة القيادة",
  nonCriminalRecord: "السجل غير الجنائي",
  tradeLicense: "الرخصة التجارية",
  registrationCertificate: "السجل التجاري",
  iconImage: "صورة الأيقونة",
  logoImage: "صورة الشعار",
  vatNumber: "رقم الضريبة",
  driverChangeRequestAttachment: "مرفق طلب تغيير السائق",
  approve: "موافقة",
  decline: "رفض",
  declineExplanation: "سبب الرفض",
  requestApproveSuccess: "تمت الموافقة على طلب السائق بنجاح",
  requestDeclineSuccess: "تم رفض طلب السائق بنجاح",
  requestFail: "فشل في طلب الموافقة/الرفض للسائق، يرجى المحاولة مرة أخرى",
  download: "تحميل الملف",
  rejectionExplanation: "سبب الرفض",
  ORDERS: "الطلبات",
  DRIVERS_REQUESTS: "طلبات السائقين",
  DASHBOARD: "لوحة البيانات",
  orderDetails: "تفاصيل الطلب",
  driverDetails: "تفاصيل السائق",
  businessDetails: "تفاصيل العمل",
  receiverDetails: "تفاصيل المستلم",
  logs: "السجلات",
  placedOn: "تاريخ الإنشاء",
  updated: "تاريخ التعديل",
  pickupDateTime: "تاريخ ووقت الاستلام",
  deliveryDateTime: "تاريخ ووقت التسليم",
  size: "الحجم",
  quantity: "الكمية",
  weight: "الوزن",
  orderFees: "رسوم الطلب",
  orderAmount: "مبلغ الطلب",
  fanoosFees: "رسوم فانوس",
  driverFees: "رسوم السائق",
  deliveryFees: "رسوم التوصيل",
  notes: "ملاحظات",
  contactPhoneNumber: "رقم هاتف الاتصال",
  isExpedited: "هل هو معجل",
  isPaid: "هل تم الدفع",
  qrCodeId: "معرف رمز QR",
  pickUpLocation: "مكان الاستلام",
  locationTitle: "عنوان الموقع",
  city: "المدينة",
  area: "المنطقة",
  street: "الشارع",
  buildingNumber: "رقم البناية",
  officeNumber: "رقم المكتب",
  floorNumber: "رقم الطابق",
  coordinates: "الاحداثيات",
  latitude: "خط العرض",
  longitude: "خط الطول",
  dropOffLocation: "مكان التسليم",
  addressName: "اسم العنوان",
  description: "الوصف",
  prefeeredPickUpDate: "تاريخ الاستلام المفضل",
  prefeeredDeliveryDate: "تاريخ التسليم المفضل",
  senderId: "معرف المرسل",
  reciverId: "معرف المتلقي",
  driverId: "معرف السائق",
  driverName: "اسم السائق",
  category: "الفئة",
  preferedVehicleType: "نوع السيارة المفضل",
  modificationDate: "تاريخ التعديل",
  userType: "نوع المستخدم",
  note: "ملاحظة",
  receiver: "المتلقي",
  driver: "السائق",
  sender: "المرسل",
  admin: "المسؤول",
  orderNumber: " رقم الطلب #",
  shipmentInfo: "معلومات الشحن",
  fees: "الرسوم",
  businessInfo: "معلومات الاعمال ",
  fullName: "اسم جهة العمل",
  phoneNumber: " رقم هاتف العمل",
  busnissType: "قطاع العمل",
  email: "البريد الإلكتروني",
  nationalNumber: " الرقم الوطني للأعمال",
  website: "الموقع الإلكتروني",
  address: "عنوان العمل",
  openHours: "ساعات العمل",
  personalInfo: "المعلومات الشخصية",
  professionalInfo: "المعلومات المهنية",
  birthday: "تاريخ الميلاد",
  education: "التعليم",
  gender: "الجنس",
  englishSpeaker: "متحدث باللغة الإنجليزية؟",
  orderCount: "عدد الطلبات",
  orderLimit: "حد الطلب",
  isOnline: "هل هو متصل بالإنترنت؟",
  collectedOrderCash: "النقود المحصلة",
  toBeCollectedOrderCash: "النقود التي سيتم تحصيلها",
  myEarnings: "أرباحي",
  expectedEarnings: "الأرباح المتوقعة",
  secondaryPhoneNumber: "رقم الهاتف الثانوي",
  noDriverAssigned: "لم يتم تعيين سائق حتى الآن",
  locationLink: "رابط الموقع",
  regular: "عادي",
  expedited: "مُعجّل",
  paid: "مدفوع",
  notPaid: "غير مدفوع",
  cancel: "إلغاء",
  orderCancellationSuccess: "تم إلغاء الطلب بنجاح",
  orderCancellationFail: "فشل في إلغاء الطلب، يرجى المحاولة مرة أخرى",
  viewLocation: "رابط الموقع",
  ordersPage: "صفحة الطلبات",
  ordersList: "قائمة الطلبات",
  orderInfo: "معلومات الطلب",
  status: "الحالة",
  senderName: "اسم العمل",
  reciverName: "اسم المستلم",
  creationDate: "تاريخ الإنشاء",
  action: "الإجراء",
  view: "عرض",
  draft: "مسودة",
  incompleteData: "بيانات غير مكتملة",
  awaitingSelection: "في انتظار الاختيار",
  pendingPickup: "في انتظار أخذ الطلب ",
  pickUpStarted: "تم بدء الاستلام",
  arrivedAtPickup: "وصل للاستلام",
  orderCollected: "تم توصيله",
  orderOutForDelivery: "خرج للتوصيل",
  arrivedAtDropOff: "وصل للتسليم",
  delivered: "تم التوصيل",
  cancelled: "ملغي",
  rejected: "مرفوض",
  onHold: "معلق",
  rescheduled: "معاد جدولته",
  returned: "مرتجع",
  failed: "فشل",
  requestDriverChange: "طلب تغيير السائق",
  driverChangeApproved: "تمت الموافقة على تغيير السائق",
  driverChangeRejected: "تم رفض تغيير السائق",
  details: "التفاصيل",
  id: "المعرف",
  orderType: "نوع الطلب",
  all: "الكل",
  date: "التاريخ",
  ordersSearch: "البحث حسب الاسم    ",
  clearFilters: "إعادة ضبط",
  noDataFound: "لم يتم العثور على بيانات",
  from: "من",
  to: "إلى",
  invalidDateRange: "النطاق الزمني خاطئ",
  Large: "كبير",
  welcomeback: "مرحبا بك",
  ordersStatistics: "احصائيات العمل ",
  totalOrders: "إجمالي الطلبات",
  activeOrders: "الطلبات النشطة",
  completedOrders: "الطلبات المكتملة",
  incompleteOrders: "الطلبات غير المكتملة",
  activeDrivers: "السائقون النشطون",
  rejectedOrders: "الطلبات المرفوضة",
  rejectedOrder: "الطلب المرفوض",
  rescheduledOrders: "الطلبات المعاد جدولتها",
  canceledOrders: "الطلبات الملغاة",
  unAssignedOrders: "الطلبات غير المعينة",
  needsAttention: "مهم",
  driverChange: "تغيير السائق",
  deliveryFailure: "فشل التوصيل",
  reject: "رفض",
  markAsResolved: "تم الحل",
  cycleTime: "زمن الدورة",
  scheduledTime: "الوقت المقرر",
  actualTime: "الوقت الفعلي",
  driverContactInformation: "معلومات التواصل مع السائق",
  name: "الأسم",
  location: "الموقع",
  businessType: "نوع العمل",
  apartmentNumber: "رقم الشقة",
  receiverName: "اسم المستلم",
  of: "من",
  jan: "ينا",
  feb: "فبر",
  mar: "مار",
  apr: "أبر",
  may: "ماي",
  jun: "يون",
  jul: "يول",
  aug: "أغس",
  sep: "سبت",
  oct: "أكت",
  nov: "نوف",
  dec: "ديس",
  pendingOrder: "طلب معلق",
  delayedDelivery: "تسليم متأخر",
  delayedPickup: "استلام متأخر",
  pendingRescheduledOrder: "طلب معلق مُعاد جدولته",
  driverChangeRequest: "طلب تغيير السائق",
  deniedOrder: "طلب مرفوض",
  canceledOrder: "طلب مُلغى",
  deliveryFailureOrder: "طلب فشل التسليم",
  driverPhoneNumber: "رقم هاتف السائق",
  senderPhoneNumber: "رقم هاتف المرسل ",
  receiverPhoneNumber: "رقم هاتف المستلم",
  contactInformation: "معلومات التواصل",
  confirmResolution: "تأكيد حل المشكلة",
  areYouSureYouWantToResolveThisIssue: "هل تريد تأكيد حل المشكلة؟",
  issueResolvedSuccessfully: "  تم الحل المشكلة  ",
  errorResolvingIssue: "لم يتم حل المشكلة",
  noDataAvailable: "لا يوجد بيانات",
  orders: "الطلبات",
  hour: "ساعة",
  hours: "ساعات",
  minute: "دقيقة",
  minutes: "دقائق",
  ago: "مضت",
  notAvaliabel: "غير متوفر",
  noDriverAssignedYet: "لم يتم تعيين سائق ",
  areYouSureYouWantToLogout: "هل تريد تسجيل الخروج؟",
  confirmLogout: "تسحيل الخروج",
  logout: "تسجيل الخروج",
  customerManagement: "إدارة العملاء",
  registrationStatus: "حالة التسجيل",
  registered: "مُسجل",
  pendingForApproval: "في انتظار الموافقة",
  active: "نشط",
  inReview: "قيد المراجعة",
  areYouSureYouWantToApprove: "هل أنت متأكد أنك تريد الموافقة؟",
  confirmAction: "تأكيد الإجراء",
  senderOrders: "طلبات المرسل",
  senderInfo: "معلومات المرسل",
  customerDetails: "تفاصيل العميل ",
  personalInformation: "المعلومات الشخصية",
  dropOffDateTime: "تاريخ ووقت التسليم",
  dispatchOrder: "تعيين الطلب ",
  availableDrivers: "السائقين المتاحين",
  nodriversavailableatthemoment: "لا يوجد سائقيين متاحين الان",
  noActiveDriversAtTheMoment: "لايوجد سائقيين  ",
  assignOrder: "تعيين الطلب ",
  goBack: "رجوع",
  phone: "رقم الهاتف",
  distance: "المسافة",
  km: "كيلو متر",
  nextSteppickupstarted: "الخطوة التالية:تم بدء الاستلام",
  nextStepArrivedAtPickup: "الخطوة التالية:وصل للاستلام",
  nextStepCollected: "الخطوة التالية:تم توصيله",
  nextStepOutForDelivery: "الخطوة التالية:خرج للتوصيل",
  nextStepArrivedAtDropoff: "الخطوة التالية:وصل للتسليم",
  nextStepDelivered: "الخطوة التالية:تم التوصيل",
  pickuptripstartedsuccessfully: "تم استلام الطلب بنجاح",
  actionnotallowedThedrivercurrentlyhasanotheractiveorder:
    "الإجراء غير مسموح: لدى السائق طلب نشط آخر",
  successfullyarrivedatpickup: "تم تغيير حالة الطلب الى الوصول لنقطة التوصيل",
  failedtocollectorder: "فشل استلام الطلب",
  ordercollectedsuccessfully: "تم استلام الطلب بنجاح",
  failedtostartdelivery: "فشل بدأ التوصيل ",
  orderisoutfordelivery: " تم بدا توصيل الطلب  ",
  successfullyarrivedatdropoff: "تم الوصول لنقطة التسليم بنجاح",
  failedtoarriveatdropoff: "فشل توصيل السائق الى نقطة التسليم",
  orderdeliveredsuccessfully: "تم توصيل الطلب بنجاح",
  failedtodeliverorder: "فشل توصل الطلب ",
  canceledOrderIssues: "الطلبات الملغية",
  rejectedOrderIssues: "الطلبات المرفوضة",
  pushNotifiaction: "إدارة الاشعارات",
  PushNotificationManagement: "إدارة الاشعارات",
  // TargetAudience:"حدد الجمهور",
  // AllDrivers:"جميع السائقين	",
  // ApprovedDrivers:"السائقين المعتمدين	",
  NotificationTitleLabel: "عنوان الإشعار",
  NotificationBodyLabel: "نص الإشعار",
  NotificationContent: "ادخل محتوى الاشعار",
  // SaveAsDraft	:"حفظ كمسودة",
  Publish: "نشر",
  requiredField: "هذا الحقل مطلوب",
  refresh: "تحديث",
  driverManagement: "إدارة السائقين",
  driverphoneNumber: "رقم السائق",
  age: "العمر",
  driverInfo: "معلومات السائق",
  driverOrders: "طلبات السائق",
  driverfullName: "الاسم الكامل ",
  drivernationalNumber: " الرقم الوطني للسائق",
  cityArea: "المدينة",
  vehicleType: "نوع المركبة",
  vehicleLicense: "رخصة المركبة",
  noDocumentsAvailable: "الوثائق غير متوفرة",
  sortAZ: "ترتيب من الألف إلى الياء",
  sortZA: "ترتيب من الياء إلى الألف",
  sortAscending: "ترتيب تصاعدي",
  sortDescending: "ترتيب تنازلي",
  contactsInformation: "تفاصيل التواصل",
  contactInfo: "معلومات الاتصال",
  contactName: "اسم الشخص المعني",
  contactPersonMopileNumber: "رقم هاتف الشخص المعني",
  occupation: "المهنة",
  loading: "  . . . جاري التحميل",
  no: "لا",
  yes: "نعم",
  isActive: "الحالة",
  inactive: "غير نشط",
  preparatory: "تحضيري",
  secondary: "ثانوي",
  bachelor: "بكالوريوس",
  female: "أنثى",
  male: "ذكر",
  retailers: "تجار التجزئة",
  manufacturers: "الشركات المصنعة",
  wholesalersDistributors: "تجار الجملة الموزعين",
  eCommercePlatforms: "منصات التجارة الإلكترونية",
  healthcarePharmaceutical: "الرعاية الصحية الصيدلانية",
  logisticsTransportation: "النقل اللوجستي",
  serviceBased: "قائم على الخدمة",
  enterResolutionReason: "أدخل سبب الحل...",
  issueType: "نوع المشكلة",
  dateAndTime: "التاريخ والوقت",
  adminSolution: "حل المسؤول",
  issuesAndSolutions: "المشاكل والحلول",
  resolutionNoteRequired: "ملاحظة الحل مطلوبة",
  receiverWhatsappNumber: " واتساب المستلم",
  searchDriverByName: "ابحث عن سائق بالاسم",
  searchCustomersByName: "ابحث عن عميل بالاسم",
  myRouteOrders: "طلبات مسار السائق",
  submit: "إرسال",
  driverphoneNumberholder: "رقم هاتف السائق",
  backToOrdersList: "العودة إلى قائمة الطلبات",
  backToCustomerManagement: "العودة إلى إدارة العملاء",
  backToDriverRequests: "العودة إلى طلبات السائقين",
  backToDriverManagement: "العودة إلى ادارة السائقيين",
  conversationFailed: "فشلت المحادثة",
  DriversLocation: "مواقع السائقين",
  activeAddress: "العنوان",
  activeTime: "الوقت",
  ActivephoneNumber: "رقم الهاتف",
  exportAs: "تصدير كـ",
  lastUpdate: "آخر تحديث",
  viewDriverLocation: "عرض موقع السائق",
  back: "رجوع",
  searchByOrderId: "ابحث برقم الطلب",
  reasonForOrderUpdate: "سبب تحديث الطلب:",
  pleaseSelectReason: "الرجاء تحديد سبب رفض الطلب.",
  damagedShipment: "شحنة تالفة",
  paymentIssues: "مشاكل في الدفع",
  receiverRefused: "رفض المستلم قبول الطلب",
  other: "أخرى:",
  typeReason: "اكتب السبب",
  save: "حفظ",
  orderRejectedSuccessfully: "تم رفض الطلب بنجاح!",
  failedToRejectOrder: "فشل رفض الطلب.",
  noDriverAssignedToOrder: "لم يتم تعيين سائق لهذا الطلب.",
  failedToFetchOrderDetails: "فشل في جلب تفاصيل الطلب.",
  pleaseSelectFailureReason: "يرجى اختيار سبب الفشل.",
  receiverUnavailable: "المستلم غير متوفر",
  receiverUnresponsive: "المستلم لا يستجيب",
  incorrectAddress: "عنوان غير صحيح",
  deliveryFailureSuccess: "تم الإبلاغ عن فشل التوصيل بنجاح!",
  deliveryFailureError: "فشل الإبلاغ عن فشل التوصيل.",
  delayOrder: "تأجيل الطلب",
  chooseDateTimeSlot: "يرجى اختيار التاريخ والوقت المفضل.",
  today: "اليوم",
  tomorrow: "غدًا",
  time: "الوقت",
  orderDelayedSuccessfully: "تمت إعادة جدولة الطلب بنجاح!",
  failedToDelayOrder: "فشلت إعادة جدولة الطلب.",
  delay: "تأجيل",
  driverChangePrompt: "أنت تطلب إسناد الطلب لسائق آخر. يرجى تحديد السبب.",
  explainReason: "اشرح السبب",
  attachmentForRequest: "مرفق للطلب",
  uploadDocuments: "تحميل مستندات",
  driverChangeRequestSuccess: "تم تقديم طلب تغيير السائق بنجاح!",
  driverChangeRequestError: "يرجى تحميل المرفق المطلوب قبل تقديم طلبك.",
  rescheduleOrder: "إعادة جدولة الطلب",
  driverRequestInformation: "معلومات طلب السائق",
  zeroFees: "رسوم صفرية",
  acceptZeroFees: "قبول الرسوم الصفرية",
  setZeroFeesDuration: "تعيين مدة الرسوم الصفرية",
  zeroStartDate: "تاريخ البداية",
  zeroEndDate: "تاريخ النهاية",
  zeroFeesUpdateSuccess: "تم تحديث حالة الرسوم الصفرية بنجاح",
  zeroFeesUpdateError: "فشل تحديث حالة الرسوم الصفرية",
};
